import React from "react";
import { Button, Card, Stack } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import { MdClose } from "react-icons/md";
import { IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";
import { useGetAddToCartDataByEmailQuery } from "../../redux/addToCart/addToCartApi";
import "./AddToCartOffcanvas.scss";
import ProductHorizontalCard from "./ProductHorizontalCard";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../init.firebase";
import { useState } from "react";
import { useEffect } from "react";

const AddToCartOffcanvas = ({ show, setShow }) => {
  const [user] = useAuthState(auth);
  const [loggedInUser, setLoggedInUser] = useState(true);
  const {
    data: allCartData,
    isLoading,
    isError,
  } = useGetAddToCartDataByEmailQuery(user?.email, {
    skip: loggedInUser,
  });

  useEffect(() => {
    if (user?.email) {
      setLoggedInUser(false);
    }
  }, [user?.email]);

  let content = null;
  if (!loggedInUser) {
    if (isLoading) {
      content = <p>Loading..</p>;
    }
    if (!isLoading && isError) {
      content = <p className="text-danger">There is something wrong!</p>;
    }
    if (!isLoading && !isError && allCartData?.products?.length === 0) {
      content = (
        <div style={{ marginTop: "50%" }} className="border-bottom pb-4">
          <h4 className="text-center">Your bag is empty</h4>
          <p className="text-center">Add your favorite items to your bag.</p>
          <Button
            onClick={() => setShow(false)}
            as={Link}
            to="/"
            className="shadow-none"
            style={{
              backgroundColor: "#7dcfb6",
              padding: "10px",
              margin: "20px 0px 10px 10px",
              fontSize: "18px",
              textAlign: "center",
              fontWeight: "bold",
              width: "95%",
              letterSpacing: "1px",
              border: "none",
            }}
          >
            Shop Now
          </Button>
        </div>
      );
    }
    if (!isLoading && !isError && allCartData?.products?.length > 0) {
      content = (
        <Stack gap={3}>
          {allCartData?.products?.map((cart) => (
            <ProductHorizontalCard key={cart?._id} cart={cart} />
          ))}
        </Stack>
      );
    }
  }
  const subTotalPrice = allCartData?.products?.reduce(
    (totalValue, currentValue) =>
      totalValue +
      currentValue?.quantity * parseInt(currentValue?.product?.price),
    0
  );

  return (
    <>
      <Offcanvas
        id="cart-offcanvas"
        show={show}
        onHide={() => setShow(false)}
        placement={"end"}
        style={{ width: "500px" }}
      >
        <Offcanvas.Header>
          <Offcanvas.Title>Your Bag</Offcanvas.Title>
          <MdClose className="fs-4" onClick={() => setShow(false)} />
        </Offcanvas.Header>
        {!allCartData && (
          <div style={{ marginTop: "50%" }} className="border-bottom pb-4">
            <h4 className="text-center">Your bag is empty</h4>
            <p className="text-center">Add your favorite items to your bag.</p>
            <Button
              onClick={() => setShow(false)}
              as={Link}
              to="/"
              className="shadow-none"
              style={{
                backgroundColor: "#7dcfb6",
                padding: "10px",
                margin: "20px 0px 10px 10px",
                fontSize: "18px",
                textAlign: "center",
                fontWeight: "bold",
                width: "95%",
                letterSpacing: "1px",
                border: "none",
              }}
            >
              Shop Now
            </Button>
          </div>
        )}
        <Offcanvas.Body>{content}</Offcanvas.Body>

        {allCartData?.products?.length > 0 && (
          <Card.Footer>
            <Button
              onClick={() => setShow(false)}
              as={Link}
              to="/checkout"
              className="shadow-none"
              style={{
                backgroundColor: "#7dcfb6",
                padding: "10px",
                margin: "0px 0px 10px 10px",
                fontSize: "18px",
                textAlign: "center",
                fontWeight: "bold",
                width: "95%",
                letterSpacing: "1px",
                border: "none",
              }}
            >
              Place Order {subTotalPrice}৳
            </Button>
            <Button
              as={Link}
              to="/shop-all"
              className="shadow-none continue_shopping"
              onClick={() => setShow(false)}
            >
              Continue Shopping <IoIosArrowForward />
            </Button>
          </Card.Footer>
        )}
      </Offcanvas>
    </>
  );
};
export default AddToCartOffcanvas;
